<template>
  <div>
    <h2 class="mb-6">Add Comas to String</h2>

    <!-- Input Field for String Without Commas -->
    <div class="field-container mb-4">
      <div class="actions-row">
        <v-btn icon text class="elevation-0" @click="pasteText">
          <v-icon>mdi-content-paste</v-icon>
        </v-btn>
      </div>
      <v-textarea
        v-model="inputString"
        label="Enter string without commas"
        outlined
      ></v-textarea>
    </div>

    <!-- Convert Button -->
    <v-btn color="primary" @click="addComas" class="mb-6">Convert</v-btn>

    <!-- Output Field for String with Commas -->
    <div class="field-container">
      <div class="actions-row">
        <v-btn icon text class="elevation-0" @click="copyText">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </div>
      <v-textarea
        v-model="outputString"
        label="Output (Commas Added)"
        readonly
        outlined
      ></v-textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddComas",
  data() {
    return {
      inputString: "",
      outputString: "",
    };
  },
  methods: {
    addComas() {
      const stringWithoutSpaces = this.inputString.replace(/\s+/g, ""); // Remove spaces
      this.outputString = stringWithoutSpaces.replace(/(.{2})(?=.)/g, "$1,"); // Add comma after every two characters
    },
    async pasteText() {
      try {
        const text = await navigator.clipboard.readText();
        this.inputString = text;
      } catch (err) {
        this.handleClipboardError("read from the clipboard");
      }
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.outputString);
      } catch (err) {
        this.handleClipboardError("copy text to the clipboard");
      }
    },
    handleClipboardError(action) {
      alert(
        `Unable to ${action}. Please make sure your browser has clipboard access.`
      );
    },
  },
};
</script>

<style>
.field-container {
  margin-bottom: 20px;
}

.actions-row {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
</style>
